var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCommon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15518_51459)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.4,
    stroke: "#E4E4E5",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15518_51459)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12,
    fill: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9874 9.59961C19.3869 9.59961 19.7107 9.92346 19.7107 10.323V19.3595C19.7107 19.759 19.3869 20.0828 18.9874 20.0828H11.5233C11.1238 20.0828 10.8 19.759 10.8 19.3595V10.323C10.8 9.92346 11.1238 9.59961 11.5233 9.59961H18.9874ZM16.003 16.8691H12.617C12.3998 16.8691 12.2238 17.0451 12.2238 17.2622C12.2238 17.4793 12.3998 17.6553 12.617 17.6553H16.003C16.2201 17.6553 16.3961 17.4793 16.3961 17.2622C16.3961 17.0451 16.2201 16.8691 16.003 16.8691ZM17.9061 14.3911H12.617C12.3998 14.3911 12.2238 14.5671 12.2238 14.7842C12.2238 15.0013 12.3998 15.1773 12.617 15.1773H17.9061C18.1232 15.1773 18.2992 15.0013 18.2992 14.7842C18.2992 14.5671 18.1232 14.3911 17.9061 14.3911ZM17.8713 11.9177H12.5821C12.365 11.9177 12.189 12.0937 12.189 12.3108C12.189 12.5279 12.365 12.7039 12.5821 12.7039H17.8713C18.0884 12.7039 18.2644 12.5279 18.2644 12.3108C18.2644 12.0937 18.0884 11.9177 17.8713 11.9177Z",
    fill: "#9FA0A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15518_51459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15518_51459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCommon);
export default __webpack_public_path__ + "static/media/file-common.83bb14f829d6c329ec039a3e1020f731.svg";
export { ForwardRef as ReactComponent };